<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 25 25">
        <defs></defs>
        <g
            id="Layer_2"
            data-name="Layer 2">
            <g
                id="Layer_1-2"
                data-name="Layer 1">
                <g
                    id="Group_18654"
                    data-name="Group 18654">
                    <g
                        id="Group_18649-2"
                        data-name="Group 18649-2">
                        <rect
                            id="Rectangle_27249-8"
                            data-name="Rectangle 27249-8"
                            class="border-rect"
                            x="0.5"
                            y="0.5"
                            width="24"
                            height="24"
                            rx="4.57" />
                        <line
                            id="Line_37-8"
                            data-name="Line 37-8"
                            class="h-separator"
                            x1="0.5"
                            y1="6.84"
                            x2="24.06"
                            y2="6.84" />
                        <path
                            id="Path_5145-8"
                            data-name="Path 5145-8"
                            class="status-light"
                            d="M6.12,3.87a1,1,0,1,1-1-1,1,1,0,0,1,1,1Z" />
                        <path
                            id="Path_5146-8"
                            data-name="Path 5146-8"
                            class="status-light"
                            d="M10,3.87a1,1,0,1,1-1-1,1,1,0,0,1,1,1Z" />
                        <path
                            id="Path_5147-8"
                            data-name="Path 5147-8"
                            class="status-light"
                            d="M13.8,3.87a1,1,0,1,1-1-1,1,1,0,0,1,1,1Z" />
                    </g>
                    <path
                        id="Path_5264-2"
                        data-name="Path 5264-2"
                        class="wrench-circle"
                        d="M18,15.77a6.19,6.19,0,1,1-6.19-6.19A6.19,6.19,0,0,1,18,15.77Z" />
                    <path
                        id="Path_5265-2"
                        data-name="Path 5265-2"
                        class="wrench"
                        d="M6.46,18.83l2.4-2.4a3.66,3.66,0,0,1,2.32-4.62A3.59,3.59,0,0,1,13,11.69L10.7,14l2.9,2.9,2.32-2.32A3.66,3.66,0,0,1,13,18.86a3.53,3.53,0,0,1-1.82-.12L8.78,21.15" />
                </g>
            </g>
        </g>
    </svg>
</template>

<style>
    .border-rect,
    .status-light,
    .wrench-circle {
        fill: #ffffff;
    }
    .border-rect,
    .status-light,
    .h-separator,
    .wrench {
        stroke: var(--bs-primary-700);
    }
    .border-rect,
    .status-light,
    .h-separator,
    .wrench-circle,
    .wrench {
        stroke-linecap: round;
        stroke-linejoin: round;
    }
    .h-separator {
        fill: none;
    }
    .wrench-circle {
        stroke: var(--bs-primary-600);
    }
    .wrench {
        fill: var(--bs-primary-200);
    }
</style>
